import { V1PromptOverrideResource } from "@generated";
import { PromptOverrideFormState } from "../types";

const formatPromptOverrideData = (
  formState: PromptOverrideFormState
): V1PromptOverrideResource => {
  const resource: V1PromptOverrideResource = {
    type: "prompt-overrides",
  };

  if (formState.id) {
    resource.id = formState.id;
  }

  resource.attributes = {
    "prompt-type": formState.promptType as "generate_executive_summary",
    content: formState.content,
    ...(formState.model.length > 0 ? { model: formState.model as any } : {}),
  };

  resource.relationships = {
    ...resource.relationships,
    "open-router-key": {
      data: formState.openRouterKeyId
        ? { id: formState.openRouterKeyId, type: "open-router-keys" }
        : { id: null, type: "open-router-keys" },
    },
  } as any;

  return resource;
};

export default formatPromptOverrideData;
